import * as d3 from 'd3'
import './styles.css'
import ScenarioChart from './ScenarioChart'

const configGlobal = {
  color: ['#509671', '#C6A85D', '#CF7979', '#B44949'],
}

const configValueGlobal = ['#509671', '#C6A85D', '#CF7979', '#B44949']
const groupData = (data, total) => {
  // const percent = d3.scaleLinear().domain([0, total]).range([0, 100])
  let cumulative = 0
  const _data = data
    .map(d => {
      cumulative += d?.value
      return {
        value: d?.value,
        cumulative: cumulative - d?.value,
        label: d?.label,
        percent: d?.label,
      }
    })
    .filter(d => d?.value > 0)
  return _data
}

const getFillValue = (type, value) => {
  let color = '#509671'
  if (type === 'chartValPeer') {
    if (value <= 25) {
      color = configValueGlobal[3]
    } else if (value <= 50) {
      color = configValueGlobal[2]
    } else if (value <= 75) {
      color = configValueGlobal[1]
    } else if (value <= 100) {
      color = configValueGlobal[0]
    }
  } else {
    if (value <= 25) {
      color = configValueGlobal[0]
    } else if (value <= 50) {
      color = configValueGlobal[1]
    } else if (value <= 75) {
      color = configValueGlobal[2]
    } else if (value <= 100) {
      color = configValueGlobal[3]
    }
  }
  return color
}
class StackedBar extends ScenarioChart {
  init({ element, data, dataRanked, widthElement, classDraw }) {
    let selection = this
    const config = {
      f: d3.format('.1f'),
      margin: { top: 1, right: 1, bottom: 1, left: 1 },
      width: widthElement,
      height: 60,
      barHeight: 16,
      colors:
        element.className === 'chartValPeer'
          ? configGlobal?.color?.slice().reverse()
          : configGlobal?.color,
    }
    const { f, margin, width, height, barHeight, colors } = config
    const w = width - margin.left - margin.right
    const h = height - margin.top - margin.bottom
    const halfBarHeight = barHeight / 2

    const total = d3.sum([...data], d => d?.value)
    const _data = groupData(data, total)
    // set up scales for horizontal placement
    const xScale = d3.scaleLinear().domain([0, total]).range([0, w])

    selection.h = h
    selection.xScale = xScale
    selection.halfBarHeight = halfBarHeight
    // create svg in passed in div
    selection.node = d3
      .select(element)
      .append('svg')
      .attr('width', '100%')
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

    // stack rect for each data value
    selection.node
      .selectAll('rect')
      .data(_data)
      .enter()
      .append('rect')
      .attr('class', 'rect-stacked')
      .attr('x', d => xScale(d?.cumulative))
      .attr('y', h / 2 - halfBarHeight)
      .attr('height', barHeight)
      .attr('width', d => xScale(d?.value))
      .style('fill', (d, i) => colors[i])

    // add some labels for percentages
    selection.node
      .selectAll('.text-percent')
      .data(_data)
      .enter()
      .append('text')
      .attr('class', 'text-percent')
      .attr('text-anchor', 'middle')
      .attr('x', d => xScale(d?.cumulative) + 12)
      .attr('y', h / 2 - halfBarHeight + 30)
      .style('fill', '#8D9CB1')
      .html((e, d) => {
        return `${e.percent}<p class="dot">th</p>`
      })

    this.update(element, data, dataRanked, classDraw)
  }

  update(element, dataUpdate, dataRankedUpdate, classDraw) {
    let selection = this
    if (dataRankedUpdate?.rankInit?.value && selection.node) {
      selection.node
        .append('circle')
        .attr('class', 'circle-init')
        .attr(
          'cx',
          d => selection.xScale(dataRankedUpdate?.rankInit?.value) - 8,
        )
        .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
        .attr('r', '7')
        .attr(
          'fill',
          getFillValue(element.className, dataRankedUpdate?.rankInit?.value),
        )
        .style('stroke', '#FFFFFF')
        .style('stroke-width', '3px')
    }

    if (dataRankedUpdate?.rankCalculate?.value && selection.node) {
      if (
        d3
          .select('.' + classDraw)
          .select('.circle-calculate')
          .size() > 0
      ) {
        d3.select('.' + classDraw)
          .select('.circle-calculate-border')
          .transition()
          // Use of easeLinear
          .ease(d3.easeLinear)
          .duration(2000)
          .attr('cx', d => {
            return selection.xScale(dataRankedUpdate?.rankCalculate?.value) - 8
          })
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '13')
          .style('fill-width', '20px')
          .style('width', '20px')
          .style(
            'fill',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('position', 'absolute')
          .style('opacity', '0.4')
          .style(
            'background-color',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('animation', 'circle-fill-anim 2.3s infinite ease-out')

        d3.select('.' + classDraw)
          .select('.circle-calculate')
          .transition()
          // Use of easeLinear
          .ease(d3.easeLinear)
          .duration(2000)
          .attr('cx', d => {
            return selection.xScale(dataRankedUpdate?.rankCalculate?.value) - 8
          })
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '7')
          .style('fill-width', '20px')
          .style(
            'fill',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('stroke', '#FFFFFF')
          .style('stroke-width', '3px')
          .style('border', '2px solid rgb(31, 56, 100)')
          .style('border-radius', '50%')
          .style('opacity', '1')
      } else {
        selection.node
          .append('circle')
          .attr('class', 'circle-calculate')
          .attr(
            'cx',
            d => selection.xScale(dataRankedUpdate?.rankInit?.value) - 8,
          )
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '7')
          .attr(
            'fill',
            getFillValue(element.className, dataRankedUpdate?.rankInit?.value),
          )
          .style('stroke', '#FFFFFF')
          .style('stroke-width', '3px')
          .transition()
          // Use of easeLinear
          .ease(d3.easeLinear)
          .duration(2000)
          .attr('cx', d => {
            return selection.xScale(dataRankedUpdate?.rankCalculate?.value) - 8
          })
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '7')
          .style('fill-width', '20px')
          .style(
            'fill',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('stroke', '#FFFFFF')
          .style('stroke-width', '3px')
          .style('border', '2px solid rgb(31, 56, 100)')
          .style('border-radius', '50%')
          .style('opacity', '1')

        selection.node
          .append('circle')
          .attr('class', 'circle-calculate-border')
          .attr(
            'cx',
            d => selection.xScale(dataRankedUpdate?.rankInit?.value) - 8,
          )
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '7')
          .attr(
            'fill',
            getFillValue(element.className, dataRankedUpdate?.rankInit?.value),
          )
          .style('stroke', '#FFFFFF')
          .style('stroke-width', '3px')
          .transition()
          // Use of easeLinear
          .ease(d3.easeLinear)
          .duration(2000)
          .attr('cx', d => {
            return selection.xScale(dataRankedUpdate?.rankCalculate?.value) - 8
          })
          .attr('cy', selection.h / 2 - selection.halfBarHeight + 8)
          .attr('r', '13')
          .style('fill-width', '20px')
          .style('width', '20px')
          .style(
            'fill',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('position', 'absolute')
          .style('opacity', '0.4')
          .style(
            'background-color',
            getFillValue(
              element.className,
              dataRankedUpdate?.rankCalculate?.value,
            ),
          )
          .style('animation', 'circle-fill-anim 2.3s infinite ease-out')
      }
    }
  }

  // clearChart() {
  //   d3.select('.chartCMSPeer').selectAll('svg').remove()
  //   d3.select('.chartValPeer').selectAll('svg').remove()
  //   d3.select('.chartLevPeer').selectAll('svg').remove()
  //   d3.select('.chartAssetCompany').selectAll('svg').remove()
  // }

  clearCircleCalculateChart(type) {
    if (type === 'csm' || type === 'all') {
      d3.select('.chartCMSPeer').selectAll('.circle-calculate').remove()
      d3.select('.chartCMSPeer').selectAll('.circle-calculate-border').remove()
    }
    if (type === 'volatility' || type === 'all') {
      d3.select('.chartValPeer').selectAll('.circle-calculate').remove()
      d3.select('.chartValPeer').selectAll('.circle-calculate-border').remove()
    }
    if (type === 'chartValPeer' || type === 'all') {
      d3.select('.chartLevPeer').selectAll('.circle-calculate').remove()
      d3.select('.chartLevPeer').selectAll('.circle-calculate-border').remove()
    }
    if (type === 'asset_volatility' || type === 'all') {
      d3.select('.chartAssetCompany').selectAll('.circle-calculate').remove()
      d3.select('.chartAssetCompany')
        .selectAll('.circle-calculate-border')
        .remove()
    }
  }
}
export default StackedBar
